import styles from './styles/InputWithBtnLayout.module.css'

export default function InputWithBtnLayout({ children }: { children: JSX.Element | JSX.Element[] }) {
  return <div className={styles.input_btn_wrap_01}>{children}</div>
}
